// extracted by mini-css-extract-plugin
module.exports = {"container":"TextArea_container__1cju3","textArea":"TextArea_textArea__2qga6","label":"TextArea_label__1H_YA"};